import { BaseSyntheticEvent } from 'react'
import Paper from '@mui/material/Paper'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'
import RadioGroup from '@mui/material/RadioGroup'
import Radio from '@mui/material/Radio'
import Divider from '@mui/material/Divider'
import { CompoundType } from 'compoundTypes'
import { useCompoundFilterContext } from 'context/CompoundFilterContext'
import { GdsFilter } from 'tableTypes'
import { useFilterBarStyles } from '../FilterBar.styles'
import Popover from '../../popover/Popover'

interface CompoundFilterProps {}

const compoundTypeFilterOptions: Array<CompoundType> = [
    'THIS_TUMOR_TYPE',
    'OTHER_TUMOR_TYPE',
    'DEVELOPMENT'
]

const gdsFilterOptions: Array<GdsFilter> = ['negative', 'positive']

const CompoundFilter = ({}: CompoundFilterProps) => {
    const { t } = useTranslation('filter')
    const styles = useFilterBarStyles()

    const {
        activeGdsFilter,
        setActiveGdsFilter,
        activeSelectFilters,
        handleActiveSelectFilterChange
    } = useCompoundFilterContext()

    const handleRadioClick = (e: BaseSyntheticEvent) => {
        const { value } = e.target
        setActiveGdsFilter(value === activeGdsFilter ? '' : value)
    }

    return (
        <Popover
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            buttonComponent={
                <Button color="primary" variant="contained">
                    {t('filter.addFilter')}
                </Button>
            }
        >
            <Paper className={styles.popoverContentContainer}>
                <div className={styles.selectFilterContainer}>
                    <RadioGroup value={activeGdsFilter}>
                        {gdsFilterOptions.map((type) => (
                            <FormControlLabel
                                key={type}
                                value={type}
                                control={<Radio onClick={handleRadioClick} />}
                                label={t(`filter.${type}`)}
                                className={styles.option}
                            />
                        ))}
                    </RadioGroup>

                    <Divider />

                    {compoundTypeFilterOptions.map((type) => (
                        <FormControlLabel
                            key={type}
                            control={
                                <Checkbox
                                    checked={activeSelectFilters.includes(type)}
                                    onChange={() =>
                                        handleActiveSelectFilterChange(type)
                                    }
                                />
                            }
                            label={t(`filter.${type}`)}
                            className={styles.option}
                        />
                    ))}
                </div>
            </Paper>
        </Popover>
    )
}

export default CompoundFilter
